

import React from "react";
import Post from './Post.js'


const posts = [
  {
    title: 'The Manju Shop That Was Born Here by Lydia Baik',
    link: 'https://digitaledition.ediblesiliconvalley.com/fall-2025/page-8',
    date: 'Published: September 1, 2025',
    blurb: `Sheui-Do Manju Shop operates under a bakery license, but instead of pastry dough, it uses a glutinous rice flour called mochiko to create its signature manju—sweet, bean-filled steamed buns. Traditionally served with hot tea, the manju’s origins trace back to the 1200s, when the steamed Chinese mantou was brought to Japan by a Buddhist monk.`,
    image: '/images/manju2.png',
    imageAlt: 'Manju',
    articleLink: 'https://digitaledition.ediblesiliconvalley.com/fall-2025/page-8',
  },
  {
    title: 'A new wave of farm-to-cone ice cream makers by Lydia Baik',
    link: 'https://www.pressdemocrat.com/2024/07/01/a-new-wave-of-farm-to-cone-ice-cream-makers/?ref=recent',
    date: 'Published: July 1, 2024 at 8:21 AM PDT',
    blurb: `In recent years, a handful of new businesses have entered Sonoma County’s ice cream scene—eco-conscious innovators and local tastemakers bringing freshly sourced recipes and unique flavors. These humble scoop shops have become multisite businesses that honor the region’s agriculture and dairy history, while pushing the boundaries of sweet and creamy. Travel along as we stroll through the county for a scoop on these local flavors and ice cream shops.`,
    image: '/images/icecream.png',
    imageAlt: 'Ice Cream',
    articleLink: 'https://www.pressdemocrat.com/2024/07/01/a-new-wave-of-farm-to-cone-ice-cream-makers/?ref=recent',
  },
  {
    title: 'Sonoma County’s annual hot air balloon show lights up the dawn by Lydia Baik',
    link: 'https://www.pressdemocrat.com/2024/08/01/sonoma-countys-annual-hot-air-balloon-show-lights-up-the-dawn/',
    date: 'Published: August 1, 2024 at 6:31 PM PDT',
    blurb: `At 4:30 a.m. in Santa Rosa, eager spectators gathered at the county fairgrounds for a dazzling display of glowing hot air balloons. The inaugural Glow Show, or “Dawn Patrol,” kicked off this year’s Sonoma County Hot Air Balloon Classic—an annual event celebrating the joy of ballooning for over thirty years.`,
    image: '/images/hotair.png',
    imageAlt: 'Hot Air Balloon',
    articleLink: 'https://www.pressdemocrat.com/2024/08/01/sonoma-countys-annual-hot-air-balloon-show-lights-up-the-dawn/',
  },
];

const tiltAngles = [-4, 4, -6, 5, -3, 3, -5, 6]; // Add more if you have more posts

function Writings() {
  return (
    <div className="writing-page">
      {posts.map((post, idx) => (
        <div className="writing-post" key={idx}>
          <span className="writing-post-pushpin" aria-hidden="true"></span>
          <div className="writing-post-content">
            <a className="writing-post-title" style={{ textAlign: 'left', display: 'block' }} href={post.link} target="_blank" rel="noopener noreferrer">
              {post.title}
            </a>
            <div className="writing-date">{post.date}</div>
            <div className="writing-blurb">
              {post.blurb}
              <br />
              <a className="writing-post-link" href={post.articleLink} target="_blank" rel="noopener noreferrer">Read Article</a>
            </div>
          </div>
          <div className="writing-image-wrapper">
            <img
              className="writing-image"
              src={post.image}
              alt={post.imageAlt}
              style={{ transform: `rotate(${tiltAngles[idx % tiltAngles.length]}deg)` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Writings;

